<mat-card class="statistics-summary-card">
  <mat-card-header>
    <mat-card-title>{{cardTitle}}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <span class="number-big">{{count == null ? '-' : count}}</span>
  </mat-card-content>
</mat-card>
